<h2 mat-dialog-title id="move-users-dialog-title">
  {{ 'MoveForms.UserMove.MoveUsers' | translate}}
</h2>

<mat-dialog-content aria-labelledby="move-users-dialog-title" aria-label="Dialog content">

  <section class="move-user-content">

    <div class="move-user-grid">
        <ag-grid-angular
          class="ag-theme-material"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          [gridOptions]="gridOptions"
          [modules]="modules"
          [suppressMovableColumns]="true"
          aria-label="User grid"
        >
        </ag-grid-angular>
    </div>

      <div class="select-organization-form">
        <app-move-to-organization-form [formVM]="orgFormVM"
          (destinationOrgChanged)="onDestinationOrgChanged($event)"
          [showDestinationBillableOrg]="true"
          [showEnableBillableOrgEdit]="true"
          aria-label="Select Organization Form"
        ></app-move-to-organization-form>
      </div>

  </section>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">{{ 'General.Cancel' | translate}}</button>
  <button mat-raised-button class="add-new-item-button" (click)="onMoveUsersClick()" [disabled]="isConfirmDisabled()">
    {{ 'MoveForms.UserMove.Move' | translate}} ({{rowData.length}}) {{
      (rowData.length > 1 ? 'MoveForms.UserMove.Users' : 'MoveForms.UserMove.User')
      | translate}}
  </button>
</mat-dialog-actions>

<ng-template #removeUserTemplate let-params>
  <i class="fas fa-trash remove-user-button"
     role="button"
     tabindex="0"
     aria-label="{{ 'MoveForms.UserMove.RemoveUser' | translate}}"
     matTooltip="{{ 'MoveForms.UserMove.RemoveUser' | translate}}"
     matTooltipPosition="above"
     (click)="onRemoveUserClick(params.userId)">
  </i>
</ng-template>
